import { GroupedChartData, TimeSeriesGroupingHelper } from '../../../../_shared/helpers/chart-grouping/time-series-grouping.helper';
import { MaintenanceInsightsResponse } from '../../maintenance-dashboard/models/maintenance-dashboard-response.model';

export type CpkGrouping = 'hourly' | 'individualHours' | 'daily' | 'weekly';

export interface CpkDataset {
  label: string;
  data: MaintenanceInsightsResponse[];
}

/**
 * Averages cost per km within each time bucket. The shared grouping helper sums values, which suits costs
 * but turns a week of daily CPK readings into a meaningless total. Points without cost data (0) are left out
 * of the average so every series is divided by the same kind of count.
 */
export function groupAverageCpk(datasets: CpkDataset[], grouping: CpkGrouping, startDate: Date, endDate: Date): GroupedChartData[] {
  const totals = groupCpk(datasets, grouping, startDate, endDate);
  const counts = groupCpk(
    datasets.map(dataset => ({
      label: dataset.label,
      data: dataset.data.map(point => ({ ...point, totalValue: point.totalValue > 0 ? 1 : 0 }))
    })),
    grouping,
    startDate,
    endDate
  );

  return totals.map((bucket, index) => {
    const averaged: GroupedChartData = { ...bucket };

    for (const { label } of datasets) {
      const count = counts[index][label];
      averaged[label] = count ? (bucket[label] ?? 0) / count : 0;
    }

    return averaged;
  });
}

function groupCpk(datasets: CpkDataset[], grouping: CpkGrouping, startDate: Date, endDate: Date): GroupedChartData[] {
  switch (grouping) {
    case 'hourly':
      return TimeSeriesGroupingHelper.groupByHours(datasets);
    case 'individualHours':
      return TimeSeriesGroupingHelper.groupByHours(datasets, true);
    case 'daily':
      return TimeSeriesGroupingHelper.groupByDays(datasets, startDate, endDate);
    default:
      return TimeSeriesGroupingHelper.groupByWeeks(datasets, startDate, endDate);
  }
}
